"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckResponse = exports.HealthCheckRequest = void 0;
class HealthCheckRequest {
}
exports.HealthCheckRequest = HealthCheckRequest;
class HealthCheckResponse {
}
exports.HealthCheckResponse = HealthCheckResponse;
//# sourceMappingURL=health-check.js.map